var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v12H0V0Z",
    fill: "#2E4E9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.438 10.083 6 16 1.562V0h-2.083L8 4.438 2.083 0H0v1.563L5.917 6 0 10.438V12h2.083L8 7.563 13.917 12H16v-1.563Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v.625L7.167 6 0 11.375V12h.833L8 6.625 15.167 12H16v-.625L8.833 6 16 .625V0h-.833L8 5.375.833 0H0Z",
    fill: "#DC251C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4V0h4v4h6v4h-6v4H6V8H0V4h6Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5V0h2v5h7v2H9v5H7V7H0V5h7Z",
    fill: "#DC251C"
  })));
};
export default SvgUk;